import { Box, Card, Tooltip, Typography } from "@mui/material"
import { useDispatch } from "react-redux";

const SelectFilesModalFolder = ({folder, setSelectFilesQuery, selectFilesQuery}) => {
    const onFolderClicks = () => {
        setSelectFilesQuery({...selectFilesQuery, folder: folder._id, page: 0})
    };

    return (
        <Card variant="outlined" sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            width: '159px',
            padding: '16px',
            cursor: 'pointer',
            transition: (theme) =>
                theme.transitions.create(["background-color, box-shadow"], {
                easing: theme.transitions.easing.easeInOut,
                duration: 200,
                }),
            "&:hover": {
                backgroundColor: "background.paper",
                boxShadow: 16,
            },
        }}  onDoubleClick={onFolderClicks}>
            <Box sx={{
                maxWidth: '40px'
            }}>
                <img src="/assets/icons/icon-folder.svg" />
            </Box>
            <Tooltip title={folder.name.length > 15 ? folder.name : ''} placement="bottom">
                <Typography variant="subtitle2">{folder.name.length > 15 ? `${folder.name.slice(0, 15)}...` : folder.name}</Typography>
            </Tooltip>
        </Card>
    )
}

export default SelectFilesModalFolder